export function getFromLocalStorage(key: string): string | null {
  if (typeof window !== 'undefined') {
    return window.localStorage.getItem(key);
  }
  return null;
}

export function getFromSessionStorage(key: string): string | null {
  if (typeof sessionStorage !== 'undefined') {
    return sessionStorage.getItem(key);
  }
  return null;
}

// Restrict value to be between the range [0, value]
export function clamp(value: number) {
  return Math.max(0, value);
}

// Check if number is between two values
export function isBetween(value: number, floor: number, ceil: number) {
  return value >= floor && value <= ceil;
}

// Scroll to anchored element
export default function scrollToAnchorTrigger(
  ev: React.MouseEvent<HTMLAnchorElement>,
) {
  ev.preventDefault();

  const { target } = ev;
  const href = (<HTMLAnchorElement>target).getAttribute('href');

  if (target instanceof HTMLAnchorElement && href && href.startsWith('#')) {
    const section = document.getElementById(href.slice(1));

    if (section) {
      const bodyHeader = document.querySelector('body > header') as HTMLElement;

      if (bodyHeader) {
        const offset = bodyHeader.clientHeight - 55;
        const bodyRect = document.body.getBoundingClientRect().top;
        const sectionRect = Math.round(section.getBoundingClientRect().top);
        const sectionPosition = sectionRect - bodyRect - offset;

        window.scrollTo({
          top: sectionPosition,
          behavior: 'smooth',
        });
      }
    }
  }
}
